<template>
  <Layout :show-nav="true" @navSwitch="navSwitch">
    <component :is="componentId" :key="componentId" />
  </Layout>
</template>

<script>
import Layout from "./components/layout.vue";
import Cervix from "./components/cervix.vue";
import CervixIn from "./components/cervixIn.vue";
import Report from "./components/report.vue";
import eruda from "eruda";

export default {
  components: { Layout, Cervix, CervixIn, Report },
  data() {
    return {
      componentId: "Cervix",
    };
  },
  mounted() {
    if (!['prod', 'uat', 'sit'].includes(process.env.VUE_APP_BASE_ENV)) eruda.init();
  },
  methods: {
    navSwitch(value) {
      this.componentId = value;
    },
  },
};
</script>

<style lang="less" scoped></style>
